import request from "./base";
const path = "/api/director";

export default {
  startJob: function(jobId) {
    return request().post(path + "/start-job", {job_id: jobId});
  },
  startBackgroundJob: function(jobId) {
    return request().post(path + "/start-job", {job_id: jobId, is_background: true});
  },
  stopJob: function(jobId) {
    return request().post(path + "/stop-job", {job_id: jobId});
  },
  stopTask: function(params) {
    return request().post(path + "/stop-task", params);
  },
};
